// extracted by mini-css-extract-plugin
export default {"pageSwitcherWrapper":"PageSwitcher_pageSwitcherWrapper__T84gn","spreadName":"PageSwitcher_spreadName__5pN2+"};